import React from 'react';
import photo from '../../../media/img/service/header_servicios.jpg';
import './servicesInfoHeader.scss';

const ServicesInfoHeader = () => {
  return (
    <div className="services-info-header">
      <div className="services-info-header__img-container">
        <div className="services-triangle-left"></div>
        <img
          className="services-info-header__img"
          src={photo}
          alt="Servicios Wonderaly"
        />
        <div className="services-triangle-right"></div>
      </div>

      <div className="services-info-header__content">
        <div className="services-info-header__title">
          <h1 className="services-info-header__title-text header-title__sub-page">
            WONDERALY SERVICIOS
          </h1>
        </div>

        <div className="services-info-header__text">
          <p className="services-info-header__text-paragraph header-subtitle__sub-page">
            Neuropsicología aplicada a la producción audiovisual y las artes
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServicesInfoHeader;
